import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import "./style/index.css";
import "./style/font.css";
import "./style/style.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
